
import { useEffect, useState } from "react"
import { ChartstwitsRepository } from "../../repository/ChartstwitsRepository";
import { useNavigate } from 'react-router-dom';

export function SearchModel() {
    const navigate = useNavigate();
    const apiModel = ChartstwitsRepository();
    const [initialDisplayCount, setInitialDisplayCount] = useState(100);
    const [tickersearchdata, setsearchdata] = useState({
        search: ''
    });

    const [lstTickers, setTickers] = useState([{
        symbol_ID: 0,
        symbol: '',
        name: '',
        industry: '',
        sector: ''
    }])

    const [lstFilterTickers, setFilterTickers] = useState([{
        symbol_ID: 0,
        symbol: '',
        name: '',
        industry: '',
        sector: ''
    }])

    const viewTickers = async () => {
        debugger;
        const responseData: any = await apiModel.getTickers('');
        debugger;
        if (responseData.length > 0) {
            debugger;
            setTickers(responseData);
        }
    }

    const sliceMainDataArray = () => {
        const slicedData = lstTickers.slice(0, initialDisplayCount);
        setFilterTickers(slicedData);
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
        debugger;
        setFilterTickers([]);
        const searchdata = e.target.value;
        setsearchdata({ 'search': searchdata });

    }

    const viewStockDetails = (d:any) =>{
        // debugger;
        const queryParams = {
            ticker: d.symbol,
        };
        const queryString = new URLSearchParams(queryParams).toString();
        navigate(`/ticker-details?${queryString}`);
    }

    useEffect(() => {
        viewTickers();
    }, [alert])

    useEffect(() => {
        if (tickersearchdata.search == '') {
            setInitialDisplayCount(100)
            sliceMainDataArray();
        } else {
            let searchResults = lstTickers.filter((x: any) => (x.symbol.toLowerCase().includes(tickersearchdata.search) || x.name.toLowerCase().includes(tickersearchdata.search)));
            debugger;
            setFilterTickers(searchResults)
        }
    }, [tickersearchdata])

    useEffect(() => {
        if (tickersearchdata.search == '') {
            sliceMainDataArray();
        }
    }, [lstFilterTickers])

    useEffect(() => {
        debugger;
        const handleScroll = () => {
            if (
                window.innerHeight + document.documentElement.scrollTop === document.documentElement.offsetHeight
            ) {
                setInitialDisplayCount(prevCount => prevCount + 100);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [])

    return { lstFilterTickers, handleChange ,viewStockDetails }
}